<template>
  <base-button
    :type="buttonType"
    size="sm"
    :loading="followLoading"
    @click="handleFollow">{{this.isFollowing() ? 'UNFOLLOW' : 'FOLLOW'}}
  </base-button>
</template>

<script>
import { mapState } from 'vuex';
import BaseButton from '../components/BaseButton.vue';

const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  name: "follow-button",
  data() {
    return {
      followLoading: false
    };
  },
  props: {
    artist_id: {
      type: String,
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  components: {
    BaseButton
  },
  computed:{
      ...mapState(["user", "isLoggedIn"]),
      followOrUnfollow() {
        return this.isFollowing();
      },
      buttonType() {
        if (this.isFollowing()) {
          return `outline-${this.type}`
        }
        return this.type;
      }
  },
  methods: {
    isFollowing() {
      if (this.isLoggedIn) {
        return this.user.following.filter((artist) => artist.artist_id == this.artist_id).length > 0;
      }
      return false;
    },
    handleFollow() {
      if (this.isLoggedIn) {
        this.followLoading = true;
          this.axios
            .post(`${apiBaseURL}/api/artv1.1/user/followartist`, {
              artist_id: this.artist_id,
              unfollow: this.isFollowing()
            })
            .then(result => {
              if (result.data.message === "Success") {
                if (result.data.data.message === "Success") {
                  this.$store.commit("setFollowing", result.data.data.following);
                }
              }
            })
            .catch(error => {
              /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
              console.error(error);
            })
            .finally(() => {
              this.followLoading = false;
            });
      } else {
        this.$store.commit("showLoginModal", true);
      }
    }
  }
}
</script>
